import { PasswordHeader } from 'components'
import { PAGE_ALERT, PAGE_TITLE } from 'pages/password-reset-required/constants'

export function PageHeader({ showAlert = false }) {
  return <PasswordHeader title={PAGE_TITLE} subtitle={showAlert && PAGE_ALERT} alert={showAlert} />
}
